import { spaces } from '@99designs/common/core/settings';
import React from 'react';
import DocumentTitle from 'react-document-title';
import styled from 'styled-components';

interface Props {
    title: string;
    textAlignment: 'left' | 'center' | 'right';
}

const StyledHeader = styled.div<Pick<Props, 'textAlignment'>>`
    text-align: ${props => props.textAlignment};
    position: relative;
`;

const Inner = styled.div`
    padding-top: ${spaces.gutter}px;
    padding-bottom: ${spaces.space8}px;
`;

const Header: React.SFC<Props> = props => {
    const { children, title, textAlignment } = props;

    return (
        <DocumentTitle title={title}>
            <StyledHeader textAlignment={textAlignment}>
                <Inner>
                    <div className="row">
                        <div className="column">{children}</div>
                    </div>
                </Inner>
            </StyledHeader>
        </DocumentTitle>
    );
};

export default Header;
